import { LicenseProduct } from './license-product';
import { AssetVehicle } from './asset-vehicle';
import { FleetAddress, SmsInviteStatus } from '@tmx/data-access';
import { BehaviorSubject } from 'rxjs';

export class LicenseUser {
  id: number | null = null;
  entityId = 0;
  externalId: string | null = null;
  email: string | null = null;
  externalName: string | null = null;
  firstName: string | null = null;
  lastName: string | null = null;
  linkedExternalId: string | null = null;
  phoneNumber: string | null = null;
  assignments: LicenseProduct[] = [];
  isSelected = false;
  isInvited = false;
  inviteSent = false;
  inviteCode: string | null = null;
  importStatus: string | null = null;
  copilotVersion: string | null = null;
  mapDataVersion: string | null = null;
  osType: string | null = null;
  osVersion: string | null = null;
  osLogo: string | null = null;
  deviceModel: string | null = null;
  isProductsExpanded$ = new BehaviorSubject(false);
  mapSets: string[] | null = null;
  vehicles: AssetVehicle[] | null = null;
  smsStatus: SmsInviteStatus | null = null;
  address: FleetAddress | null = null;
  lat: number | null = null;
  lon: number | null = null;
  lastStoredTimeStamp: Date | null = null;

  constructor(values: LicenseUser | Record<string, unknown> = {}) {
    Object.assign(this, values);

    const id = values.id;
    this.entityId = typeof id === 'number' ? id : 0;
  }

  get inviteStatus(): string | null {
    // must be handled at user level because Braze event is a userInvite
    if (this.email === null || this.email === '' || !this.assignments.length) {
      return null;
    }
    if (this.isInvited) {
      return 'Re-send';
    }
    return 'Invite';
  }
}
